exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mapboxgl-ctrl,\n.Mapbox__zoomControl-zS {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n", ""]);

// exports
exports.locals = {
	"zoomControl": "Mapbox__zoomControl-zS"
};